import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

type CardProps = {
  count: number;
  title: string;
  icon: React.ReactNode;
};
const NumberCard: React.FC<CardProps> = ({ count, title, icon }) => {
  return (
    <Card sx={{ minWidth: 150, height: "100%" }}>
      <CardHeader avatar={icon} title={title} />
      <CardContent>
        <Typography variant="h2" component="p">
          {count}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default NumberCard;
